import { render, staticRenderFns } from "./BuyBusienes.vue?vue&type=template&id=46c08a60&scoped=true&"
import script from "./BuyBusienes.vue?vue&type=script&lang=js&"
export * from "./BuyBusienes.vue?vue&type=script&lang=js&"
import style0 from "./BuyBusienes.vue?vue&type=style&index=0&id=46c08a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c08a60",
  null
  
)

export default component.exports